import { createElement, ComponentType } from "react";

type IconProps = {
  icon: ComponentType<any> | null;
  height?: string;
  width?: string;
  className?: string;
} & Record<string, unknown>;

/**
 * It takes in an icon, height, width, fill, and className, and returns an SVG icon with the given
 * height, width, fill, and className
 * @returns A React component that takes in props and returns an SVG icon.
 */
export const Icon = ({
  icon,
  height,
  width,
  className,
  ...props
}: IconProps) => {
  if (!icon) {
    return null;
  }

  return (
    <>
      {createElement(icon, {
        className: `${height ? height : "h-3"} ${
          width ? width : "w-3"
        } ${className}`,
        ...props,
      })}
    </>
  );
};
